export default __webpack_public_path__ + "static/media/github.5cb865b1.svg";